<template>
    <section class="app-main">
        
        <div class="top-bar">
            <el-button  class="top-btn" type="primary" plain @click="dialog = true">添加</el-button >
        </div>

        <el-card class="content">
            <el-table :data="tableData" empty-text="暂无优惠券"  height="600" style="width: 100%">
                <el-table-column prop="title" label="背景图" align="center" >
                    <template slot-scope="scope">
                        <m-img v-if="scope.row.pic"  :src="scope.row.pic.url" :width="351" :height="114" />
                    </template>
                </el-table-column>
                <el-table-column prop="created_at"  align="center" label="上传日期" ></el-table-column>
                <el-table-column prop="flag"  align="center" label="状态">
                    <template slot-scope="scope">
                        <el-link type="success" v-if="scope.row.flag == 1">已启用</el-link>
                        <el-link type="info"    v-if="scope.row.flag == 2">已禁用</el-link>
                    </template>
                </el-table-column>
                <el-table-column label="编辑" align="center">
                    <div slot-scope="scope" class="table-btns">
                        <el-button type="success" plain size="mini" v-if="scope.row.flag == 2" @click="handleFlag(scope.row, 1)">启用</el-button >
                        <el-button type="info"    plain size="mini" v-if="scope.row.flag == 1" @click="handleFlag(scope.row, 2)">禁用</el-button >
                    </div>
                </el-table-column>
            </el-table>
            <el-pagination background @current-change="reloadData" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="size"></el-pagination>
        </el-card>
        
         <!-- 添加优惠券背景 -->
        <el-dialog title="添加优惠券背景" :visible.sync="dialog" :show-close="false" width="600px" center>
            <el-row type="flex" justify="center">
                <m-upload :img.sync="img"  :width="351" :height="114" file-name="Coupon"  placement="right" />
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button style="width:150px" @click="dialog = false">取 消</el-button>
                <el-button style="width:150px" type="primary" @click="handleBtn">确 定</el-button>
            </div>
        </el-dialog>

    </section>
</template>



<script>
import { coupon_bg, coupon_bg_add, coupon_bg_put } from '@/api/market.js'
import MImg   from './../../../components/Image'
import MUpload from '@/components/m-upload.vue'
export default {
    components: { MImg, MUpload },
    data() {
        return {
            tableData:[],
            total: 0,
            page: 1,
            size: 20,
            dialog: false,
            img: { pic_id: '', url: '' }
        }
    },
    methods: {
        search(){
           
        },
        getData(){
            coupon_bg().then(res => {
                if(res){
                    this.tableData = res.data
                }else{
                    this.tableData = [];
                    this.size = res.data.per_page
                    this.total = res.data.total
                    this.$message.error(res.msg)
                }
            }).catch(err => {
                this.table_load = false
                console.log(err)
            })
        },
        reloadData(page){
            this.page = page;
            this.getData();
        },
       
       // 启用  禁用
       handleFlag(row, flag) {
           console.log(flag)
           let params = {
               flag: flag
           }
           coupon_bg_put(row.id, params).then(res => {
               if(res) {
                   
                this.getData() 
                 this.$message({type:"success",message:res.msg})
               }
           })
       },

      // 添加优惠券背景
       handleBtn() {
           let params = {}
           if(this.img.pic_id == '') {
               this.$message.error('请先上传背景图')
               return false
           }else {
               params.pic_id = this.img.pic_id
           }
           coupon_bg_add(params).then(res => {
               if(res) {
                 this.dialog = false
                 this.getData() 
                 this.img =  { pic_id: '', url: '' }
                 this.$message({type:"success",message:res.msg})
               }
           })
       }
        

     
    },
    created(){
        this.getData()
    },
    activated() {
        this.getData()
    },
}
</script>

<style lang="less" scoped>
section {
    .top-btn {
        width: 100px;
    }
    .input-label {
            height: 40px;
            line-height: 40px;
            min-width: 98px;
        }
}
</style>
